import React from "react";
import "../styles/cookieBanner.css";

const STORAGE_KEY = "ph_cookie_consent"; // 'accepted' | 'dismissed'

export default function CookieBanner() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  }

  // If you ever want a decline button, add one and store "dismissed".
  // function decline() {
  //   localStorage.setItem(STORAGE_KEY, "dismissed");
  //   setVisible(false);
  // }

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Sütik tájékoztató">
      <div className="container cookie-inner">
        <p className="cookie-text">
          A weboldal sütiket használ. További információ:{" "}
          <a href="/adatvedelem.pdf" target="_blank" rel="noopener noreferrer">
            Adatvédelem
          </a>
        </p>
        <div className="cookie-actions">
          <button
            className="cookie-btn "
            onClick={accept}
            aria-label="Elfogadom"
          >
            Értem!
          </button>
          {/* <button className="cookie-link" onClick={decline}>Elutasítom</button> */}
        </div>
      </div>
    </div>
  );
}
